<template>
    <academic>
        <card-header :title="'Topic: '+topic.title" />
        <div class="grid grid-cols-2 gap-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
                <p class="text-lg font-medium mb-4">Topic Notes</p>
                <div>
                    <dropbox :link="route('academic.topic.notes.submitnotes',topic.id)" :format="'Pdf'" accept="application/pdf"/>
                    <breeze-table :items="topic.notes" :fields="fields" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Subject')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Subject')">
                        <template #title="data">
                            <a :href="data.item.file" class="text-blue-600 underline">{{data.item.title}}</a>
                        </template>
                        <template #action="data">
                            <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Subject')" :href="route('academic.topic.notes.delete',data.item.id)" >Delete</button-link>
                        </template>
                    </breeze-table>
                </div>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing" />
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Links</p>
                    <form @submit.prevent="submitForm">
                        <div>
                            <div class="grid grid-cols-8 gap-4 mb-8 items-center" v-for="link,index in form.links" :key="index">
                                <div class="col-span-8 sm:col-span-8">
                                    <breeze-label :value="'Link Title'"/>
                                    <breeze-input required v-model="form.links[index].title" class="w-full"/>
                                    <breeze-input-error :message="form.errors?form.errors['links.'+index+'.title']:''" />
                                </div>
                                <div class="col-span-6 sm:col-span-6">
                                    <breeze-label :value="'Link'"/>
                                    <breeze-input required v-model="form.links[index].link" class="w-full"/>
                                    <breeze-input-error :message="form.errors?form.errors['links.'+index+'.link']:''" />
                                </div>
                                <div>
                                    <breeze-label :value="'Status'"/>
                                    <breeze-checkbox v-model="form.links[index].status" :checked="form.links[index].status"/>
                                    <breeze-input-error :message="form.errors?form.errors['links.'+index+'.status']:''" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer text-red-500" viewBox="0 0 20 20" fill="currentColor" @click="removeLink(index)">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <breeze-button type="button" class="mb-4" @click="addLink">Add</breeze-button>
                        </div>

                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Topic Added!</span>
                        <exception />
                    </form>
                </div>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import Exception from '@/Components/Exception'
    import Dropbox from '@/Components/Dropbox'

    export default {
        components: {
            Academic,
            BreezeInput,
            BreezeTable,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            Dropbox
        },
        props:['topic'],
        data(){
            return{
                form: useForm({
                    links: this.topic.links,
                }),
                fields:[{'key':'title','label':'Title'},{'key':'action','label':'Action'}]
            }
        },
        methods:{
            submitForm() {
                this.form.post(route('academic.topic.notes.submitlinks',this.topic.id),{
                    preserveScroll: true,
                    onSuccess: () => {this.form.reset(); location.reload()},
                });
            },
            addLink(){
                this.form.links.push({'title':'','link':'','status':true})
            },
            removeLink(index){
                this.form.links.splice(index,1)
            }
        }
    }
</script>
